var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/global"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/global_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "global"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M7.65 21.41C7.62 21.41 7.58 21.43 7.55 21.43C5.61 20.47 4.03 18.88 3.06 16.94C3.06 16.91 3.08 16.87 3.08 16.84C4.3 17.2 5.56 17.47 6.81 17.68C7.03 18.94 7.29 20.19 7.65 21.41Z",
    fill: "#00927B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M20.94 16.95C19.95 18.94 18.3 20.55 16.29 21.52C16.67 20.25 16.99 18.97 17.2 17.68C18.46 17.47 19.7 17.2 20.92 16.84C20.91 16.88 20.94 16.92 20.94 16.95Z",
    fill: "#00927B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M21.02 8.20998C19.76 7.82998 18.49 7.51998 17.2 7.29998C16.99 6.00998 16.68 4.72998 16.29 3.47998C18.36 4.46998 20.03 6.13998 21.02 8.20998Z",
    fill: "#00927B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.4,
    d: "M7.65001 3.59C7.29001 4.81 7.03001 6.05 6.82001 7.31C5.53001 7.51 4.25001 7.83 2.98001 8.21C3.95001 6.2 5.56001 4.55 7.55001 3.56C7.58001 3.56 7.62001 3.59 7.65001 3.59Z",
    fill: "#00927B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.49 7.09C13.17 6.83 10.83 6.83 8.51001 7.09C8.76001 5.72 9.08001 4.35 9.53001 3.03C9.55001 2.95 9.54001 2.89 9.55001 2.81C10.34 2.62 11.15 2.5 12 2.5C12.84 2.5 13.66 2.62 14.44 2.81C14.45 2.89 14.45 2.95 14.47 3.03C14.92 4.36 15.24 5.72 15.49 7.09Z",
    fill: "#00927B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.59 15.99C5.21 15.74 3.85 15.42 2.53 14.97C2.45 14.95 2.39 14.96 2.31 14.95C2.12 14.16 2 13.35 2 12.5C2 11.66 2.12 10.84 2.31 10.06C2.39 10.05 2.45 10.05 2.53 10.03C3.86 9.59001 5.21 9.26001 6.59 9.01001C6.34 11.33 6.34 13.67 6.59 15.99Z",
    fill: "#00927B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M22 12.5C22 13.35 21.88 14.16 21.69 14.95C21.61 14.96 21.55 14.95 21.47 14.97C20.14 15.41 18.78 15.74 17.41 15.99C17.67 13.67 17.67 11.33 17.41 9.01001C18.78 9.26001 20.15 9.58001 21.47 10.03C21.55 10.05 21.61 10.06 21.69 10.06C21.88 10.85 22 11.66 22 12.5Z",
    fill: "#00927B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.49 17.91C15.24 19.29 14.92 20.65 14.47 21.97C14.45 22.05 14.45 22.11 14.44 22.19C13.66 22.38 12.84 22.5 12 22.5C11.15 22.5 10.34 22.38 9.55001 22.19C9.54001 22.11 9.55001 22.05 9.53001 21.97C9.09001 20.64 8.76001 19.29 8.51001 17.91C9.67001 18.04 10.83 18.13 12 18.13C13.17 18.13 14.34 18.04 15.49 17.91Z",
    fill: "#00927B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M15.7633 16.2633C13.2622 16.5789 10.7378 16.5789 8.23667 16.2633C7.92111 13.7622 7.92111 11.2378 8.23667 8.73667C10.7378 8.42111 13.2622 8.42111 15.7633 8.73667C16.0789 11.2378 16.0789 13.7622 15.7633 16.2633Z",
    fill: "#00927B"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.4d509300bbfcdcfe58beba67feec853d.svg";
export { ForwardRef as ReactComponent };